import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {
  getNewDriveBannerData,
  talentBridgeContants,
  extractDate,
} from './utils';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

const TalentBridgeTopBanner: React.FC = () => {
  const [date, setDate] = useState<string | null>(null);
  const [city] = useState<string>('bangalore');
  const [displayDate, setDisplayDate] = useState<string | null>(null);
  const theme = useWrappedTheme();

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const obj = await getNewDriveBannerData(city);
        const extractedDisplayDate = extractDate(
          obj?.date || '',
          obj?.month || ''
        );
        setDisplayDate(extractedDisplayDate);
        const extractedDate = obj?.eventDates || '';
        setDate(extractedDate);
      } catch (err) {
        console.error('Error fetching drive banner data:', err);
      }
    };
    fetchBanner();
  }, []);

  let showBanner = false;
  if (date) {
    const [startStr, endStr] = date.split(' - ');
    const [day1, month1, year1] = startStr.split('/').map(Number);
    const startDate = new Date(year1, month1 - 1, day1);
    const [day2, month2, year2] = endStr.split('/').map(Number);
    const endDate = new Date(year2, month2 - 1, day2);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (today >= startDate && today <= endDate) {
      showBanner = true;
    }
  }
  if (!showBanner) return null;

  return (
    <Box
      sx={{
        width: 'auto',
        height: 'auto',
        minHeight: 50,
        padding: 1.125, // 9px
        backgroundColor: 'secondary.main',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: 'auto',
          height: 'auto',
          margin: '5px 10px 5px 0',
          fontSize: theme.typography.pxToRem(16),
          fontWeight: 600,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 'normal',
          letterSpacing: 'normal',
          color: '#fff',
          '& span': {
            fontWeight: 800,
          },
        }}
      >
        <span>Hirist Talent Bridge</span> – Live Hiring Drive{' '}
        {displayDate ? `on ${displayDate}` : ''}
      </Box>
      <Box
        component={'a'}
        href={`/talent-bridge-hiring-drive/${city}?ref=${talentBridgeContants.refCode_temp}`}
        sx={{
          width: 'auto',
          maxWidth: 123,
          minHeight: 32,
          margin: '0 0 0 10px',
          padding: '7px 11px',
          borderRadius: 1,
          backgroundColor: 'primary.main',
          fontSize: theme.typography.pxToRem(13),
          fontWeight: 'bold',
          color: '#fff',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          boxShadow: 'none',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: 'primary.dark',
            boxShadow: 'none',
          },
        }}
      >
        Register Now
      </Box>
    </Box>
  );
};

export default TalentBridgeTopBanner;
